import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
// import redzs from '../../images/zs/zscar.webp';
// import greyzs from '../../images/zs/greyzs.webp';
// import whitezs from '../../images/zs/whitezs.webp';
// import blackzs from '../../images/zs/blackzs.webp';
const redzs ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mgzsev-electric-car%2Fzs-img-dsc-0319.webp?alt=media&token=3cdff67f-bef3-48e5-8c91-11a265c14361"
  const greyzs ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mgzsev-electric-car%2Fzs-img-dsc-0320.webp?alt=media&token=9b453362-c246-4f5b-97df-d7a64000f39f"
  const whitezs ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mgzsev-electric-car%2Fzs-img-dsc-0321.webp?alt=media&token=1718a2bb-a9ec-4401-8fc4-d36b44e5d99d"
  const blackzs ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mgzsev-electric-car%2Fzs-img-dsc-0318.webp?alt=media&token=c9ac5f81-19dc-4130-8a0e-36c8c60c3469"
const CustomCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [fixedImage, setFixedImage] = useState(redzs); 

  const carImages = [
    { src: redzs, alt: "redzs", color: "#c91f1f" },
    { src: greyzs, alt: "greyzs", color: "#D1D1DB" },
    { src: blackzs, alt: "blackzs", color: "#000000" },
    { src: whitezs, alt: "Whitezs", color: "#ffffff" },
  ];

  const handleSelect = (index) => {
    setActiveIndex(index);
    setFixedImage(carImages[index].src); 
  };

  
  return (
    <div style={{ position: "relative",margin:0,padding:0 }}>
      <Carousel 
        activeIndex={activeIndex} 
        onSelect={handleSelect} 
        interval={null} 
        pause={false}
        indicators={false}
        controls={false}
      >
        {carImages.map((car, index) => (
          <Carousel.Item key={index}>
            <img className="d-block w-100" src={fixedImage} alt={car.alt} />
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Custom Circle Indicators */}
      <div style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "12px" }}>
        {carImages.map((car, index) => (
          <div
            key={index}
            onClick={() => handleSelect(index)}
            style={{
              width: "23px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: activeIndex === index ? car.color : car.color, 
              cursor: "pointer",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomCarousel;